import { typeOf } from '@ember/utils';

/**
 * @returns {boolean} Returns true if the argument starts with a number
 */
export default function isNum(arg) {
  const parsed = parseFloat(arg);
  return typeOf(parsed) === 'number' && !Number.isNaN(parsed);
}
